export default __webpack_public_path__ + "static/Bevel-41140404939c9626c83c25e1d8af71da.jpg";